import { render, staticRenderFns } from "./SideTagsTrack.vue?vue&type=template&id=9b2818b6&scoped=true&"
import script from "./SideTagsTrack.vue?vue&type=script&lang=js&"
export * from "./SideTagsTrack.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsTrack.vue?vue&type=style&index=0&id=9b2818b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2818b6",
  null
  
)

export default component.exports